<template>
  <app-page-gradient-background>
    <home-page-hero />

    <app-page-wrapper
      class="flex flex-col gap-16 md:gap-24"
      :class="{ 'mt-10': !newHomeEnabled }"
    >
      <app-page-subsection
        v-if="topTeachers.length > 0"
        subtitle="+500 experts en poste, sélectionnés et accompagnés, par Pollen partagent leurs pratiques et méthodes."
        title="Accédez aux meilleurs experts en poste, sur chaque métier"
      >
        <teacher-card-carousel
          content-visibility="visible"
          :list="topTeachers"
          show-description-short
        />
      </app-page-subsection>
    </app-page-wrapper>

    <app-page-wrapper class="my-16 md:my-24" contained-by="content">
      <div
        class="before:bg-deco2 relative p-4 before:absolute before:inset-0 before:rounded-xl before:rounded-br-[theme(spacing.12)] sm:p-6 sm:!pb-0 sm:before:bottom-[theme(spacing.12)] lg:p-12"
      >
        <brand-offer-section class="relative" />
      </div>
    </app-page-wrapper>

    <app-page-wrapper class="flex flex-col gap-16 md:gap-24">
      <app-page-subsection
        v-if="events.length > 0"
        subtitle="Participez à nos rencontres exclusives entre pairs, découvrez nos formats et nos trainers."
        title="Les évenements du Pollen Club"
        :to="{ name: 'events' }"
      >
        <event-card-carousel :list="events" />
      </app-page-subsection>

      <brand-nps-banner />

      <app-page-subsection
        v-if="posts?.length"
        title="Derniers articles"
        to="/blog"
      >
        <blog-post-card-carousel :list="posts" />
      </app-page-subsection>

      <brand-qualiopi-banner />
    </app-page-wrapper>
  </app-page-gradient-background>
</template>

<script lang="ts" setup>
import HomePageHero from "~/pages/index/_includes/components/home-page-hero.vue";

definePageMeta({
  transparentHeader: true,
});

const { data: topTeachers } = useTopTeacherList("home-top-teachers", {
  limit: 12,
});

const { data: events } = useEventList({
  from: startOfTomorrow().toDate().toISOString(),
  sortField: "start_date",
  sortOrder: "ASC",
});

const { data: posts } = useBlogPostList({
  searchable: true,
  limit: 10,
});

const newHomeEnabled = useFeatureFlag("new_home");
</script>
